require('./accountDebitChangeAccountDetailsBox.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ utilities
const { FormattedText } = require('core/i18n').i18n;


class AccountDebitChangeAccountDetailsBox extends React.Component {
    render() {
        const { match: { params: { accountId, receiptNumber } }, immAccountDebits, immAccounts } = this.props;
        const receiptStatus = immAccountDebits.hasIn([accountId, 'byId', receiptNumber]);

        if (receiptStatus) {
            const receipt = immAccountDebits.getIn([accountId, 'byId', receiptNumber]);

            const description = receipt.get('description');
            const beneficiaryName = receipt.get('beneficiaryName');
            const issuingCompanyId = receipt.get('issuingCompanyId');
            const referenceNumber = receipt.getIn(['reference', 'referenceNumber']);
            const beneficiaryIban = immAccounts.getIn(['byId', accountId]).get('iban');

            return (
                <OKSectionBox className="account-details__receipt-details">
                    <h1 className="account-details__title">
                        <FormattedText value="accountDebitDetail-header" />
                    </h1>
                    <section className="account-details__field">
                        <h2 className="account-details__subtitle">
                            <FormattedText value="accountDebitDetail-description" />
                        </h2>
                        <div className="account-details__value">
                            {description}
                        </div>
                    </section>

                    <section className="account-details__field">
                        <h2 className="account-details__subtitle">
                            <FormattedText value="accountDebitDetail-beneficiaryName" />
                        </h2>
                        <div className="account-details__value">
                            {beneficiaryName}
                        </div>
                    </section>

                    <section className="account-details__field">
                        <h2 className="account-details__subtitle">
                            <FormattedText value="accountDebitDetail-receiptNumber" />
                        </h2>
                        <div className="account-details__value">
                            {receiptNumber}
                        </div>
                    </section>

                    <section className="account-details__field">
                        <h2 className="account-details__subtitle">
                            <FormattedText value="accountDebitDetail-issuingCompanyId" />
                        </h2>
                        <div className="account-details__value">
                            {issuingCompanyId}
                        </div>
                    </section>

                    <section className="account-details__field">
                        <h2 className="account-details__subtitle">
                            <FormattedText value="accountDebitDetail-referenceNumber" />
                        </h2>
                        <div className="account-details__value">
                            {referenceNumber}
                        </div>
                    </section>

                    <section className="account-details__field">
                        <h2 className="account-details__subtitle">
                            <FormattedText value="accountDebitDetail-ibanAccount" />
                        </h2>
                        <div className="account-details__value">
                            {beneficiaryIban}
                        </div>
                    </section>
                </OKSectionBox>
            );
        }
        else {
            return (
                <OKSectionBox className="account-details__receipt-details">
                    <LoadingSection />
                </OKSectionBox>
            );
        }
    }
}

AccountDebitChangeAccountDetailsBox.propTypes = {
    immAccountDebits: PropTypes.object,
    immAccounts: PropTypes.object,
    match: PropTypes.object,
};

module.exports.AccountDebitChangeAccountDetailsBox = AccountDebitChangeAccountDetailsBox;
